import Direction from "views/logic/aggregationbuilder/Direction";
export const PAGINATION = {
  INITIAL_PAGE: 1,
  PER_PAGE: 10
};
export const SORT_DIRECTION_OPTIONS = [Direction.Ascending.direction, Direction.Descending.direction];
